import * as React from 'react';
import { useState } from "react";
import { 
    Button, 
    Typography, 
    Box,
} from "@mui/material";
import ListIcon from '@mui/icons-material/List';
import CachedIcon from '@mui/icons-material/Cached';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { ReindexModal, ReindexRouteModal, CleanCacheModal, SitemapModal } from 'src/resources/configuration/commands';

export function ConfigurationToolbar() {
    const [reindexModal, setReindexModal] = useState(false);
    const [cleanCacheModal, setCleanCacheModal] = useState(false);
    const [reindexRouteModal, setReindexRouteModal] = useState(false);
    const [sitemapModal, setSitemapModal] = useState(false);

    const setReindexModalHandler = (value: boolean) => {
        setReindexModal(value);
    }
    
    const setReindexRouteModalHandler = (value: boolean) => {
        setReindexRouteModal(value);
    }

    const setCleanCacheModalHandler = (value: boolean) => {
        setCleanCacheModal(value);
    }

    const setSitemapModalHandler = (value: boolean) => {
        setSitemapModal(value);
    }

    return (
        <>
        <Box marginY="10px" display="flex" gap="5px" alignSelf="end">
            <Button onClick={() => setSitemapModalHandler(true)} variant="outlined" size="small">
                <AccountTreeIcon sx={{ fontSize: "18px"}} />
                <Typography component="span" sx={{lineHeight: "1.75", fontSize: "14px", marginLeft: "8px", fontWeight: 600}}>Generate Sitemap</Typography>
            </Button>
            <Button onClick={() => setReindexModalHandler(true)} variant="outlined" size="small">
                <ListIcon sx={{ fontSize: "18px"}} />
                <Typography component="span" sx={{lineHeight: "1.75", fontSize: "14px", marginLeft: "8px", fontWeight: 600}}>Reindex ElasticSearch</Typography>
            </Button>
            <Button onClick={() => setReindexRouteModalHandler(true)} variant="outlined" size="small">
                <ListIcon sx={{ fontSize: "18px"}} />
                <Typography component="span" sx={{lineHeight: "1.75", fontSize: "14px", marginLeft: "8px", fontWeight: 600}}>Reindex Route</Typography>
            </Button>
            <Button onClick={() => setCleanCacheModalHandler(true)} variant="outlined" size="small">
                <CachedIcon sx={{ fontSize: "18px"}} />
                <Typography component="span" sx={{lineHeight: "1.75", fontSize: "14px", marginLeft: "8px", fontWeight: 600}}>Clean Cache</Typography>
            </Button>
        </Box>

        {reindexModal &&
        <ReindexModal
            open={reindexModal}
            setOpen={setReindexModalHandler}
        />
        }

        {reindexRouteModal &&
        <ReindexRouteModal
            open={reindexRouteModal}
            setOpen={setReindexRouteModal}
        />
        }

        {cleanCacheModal &&
        <CleanCacheModal
            open={cleanCacheModal}
            setOpen={setCleanCacheModalHandler}
        />
        }

        {sitemapModal &&
        <SitemapModal
            open={sitemapModal}
            setOpen={setSitemapModalHandler}
        />
        }

        </>
    );
}